import { EnvironmentName } from '../app/enums/environment-name.enum';

export const environment = {
  appVersion: require('../../package.json').version,
  name: EnvironmentName.STAGING_US,
  production: false,
  secureCookie: true,
  appUrl: 'https://us.staging.digitalpractice.vet',
  backendUrl: 'https://api.us.staging.digitalpractice.vet/api',
  authUrl: 'https://auth-staging-us.digitalpractice.vet',
  helpUrl: 'https://help.us.staging.digitalpractice.vet',
  billingUrl: 'https://billing-us-staging.digitalpractice.vet',
  authClientId: '936d85f6-a25f-4d51-b73d-d8950faf4990',
  formsApiUrl: 'https://us.forms.api.staging.digitalpractice.vet',
  formsFrontEndUrl: 'https://us.forms.staging.digitalpractice.vet',
  websocketUrl: 'https://api.us.staging.digitalpractice.vet',
  maxImageSize: 1400,
  appLogo: '/assets/images/dp-thumb.svg',
  appWideLogo: '/assets/images/dp-logo.svg',
  login: {
    services: ['vhd'],
    logo: '/assets/images/dp-logo.svg',
    logoSize: 'large',
  },
  gtag_code: 'G-PNL5E45G8R',
  oneSignal: {
    appId: '2f49891d-0e9d-4385-85e9-dbb6623e059d',
    safariWebId: ''
  },
  jwtPrefix: 'STAGING_MESSAGING_US_',
  noPracticesMessage: 'You do not have access to any practices. Please contact your system administrator.',
  campaignLimit: 750,
  conversationsPerPage: 20,
  productRequestsPerPage: 20,
  clientsPerPage: 20,
  paymentsPerPage: 20,
  templateMessageLength: 1000,
  intercomAppId: 'moomgsp0',
};
